import $ from 'jquery';
import noUiSlider from 'nouislider';
import { inventoryLocalization, formatPrice, formatMileage } from './translations';

const filter = document.getElementById('select-slider');

const price_range = $('#price-range');
const price_range_text = $('#price-range-text');
const price_range_max = $('#price_max');
const price_range_min = $('#price_min');

const mileage_range = $('#mileage-range');
const mileage_range_text = $('#mileage-range-text');
const odometer_range_max = $('#odometer-max');
const odometer_range_min = $('#odometer-min');

function priceSliderText(minValue, maxValue, modify) {
  minValue = parseInt(minValue);
  maxValue = parseInt(maxValue);

  if (modify == 1) {
    $('#price-range').slider('values', 0, minValue);
    $('#price-range').slider('values', 1, maxValue);
  }

  if (minValue == 0 && maxValue < 76000) {
    return `Up to ${formatPrice(maxValue)}`;
  } else if (minValue > 0 && maxValue == 76000) {
    return `${formatPrice(minValue)} and up`;
  } else if (minValue > 0 && maxValue < 76000) {
    return `${formatPrice(minValue)} to ${formatPrice(maxValue)}`;
  }
  return inventoryLocalization.gettext('No minimum or maximum');
}

function mileageSliderText(minValue, maxValue, modify) {
  minValue = parseInt(minValue);
  maxValue = parseInt(maxValue);
  if (modify == 1) {
    $('#mileage-range').slider('values', 0, minValue);
    $('#mileage-range').slider('values', 1, maxValue);
  }

  if (minValue == 0 && maxValue < 260000) {
    return `Up to ${formatMileage(maxValue)}`;
  } else if (minValue > 0 && maxValue == 260000) {
    return `${formatMileage(minValue)} and up`;
  } else if (minValue > 0 && maxValue < 260000) {
    return `${formatMileage(minValue)} to ${formatMileage(maxValue)}`;
  }
  return inventoryLocalization.gettext('No minimum or maximum');
}

if (filter) {
  noUiSlider.create(price_range[0], {
    start: [0, 100000],
    step: 2000,
    behaviour: 'drag',
    connect: true,
    range: {
      min: [0],
      max: [100000],
    },
    format: formatPrice,
  });

  price_range[0].noUiSlider.on('update', function (values) {
    price_range_text.html(priceSliderText(values[0], values[1]));
    price_range_min.val(values[0]);
    price_range_max.val(values[1]);
  });

  noUiSlider.create(mileage_range[0], {
    start: [0, 260000],
    step: 2000,
    behaviour: 'drag',
    connect: true,
    range: {
      min: [0],
      max: [260000],
    },
    format: formatMileage,
  });

  mileage_range[0].noUiSlider.on('update', function (values) {
    mileage_range_text.html(mileageSliderText(values[0], values[1]));
    odometer_range_min.val(values[0]);
    odometer_range_max.val(values[1]);
  });
}
